import { PrimaryImageType } from "../../types/mainModulTypes"
import BaseMedia from "../common/BaseMedia"

export default function PrimaryImage(props: PrimaryImageType) {

    return (
        <div className=" mx-auto md:px-4 lg:px-0">
            <BaseMedia media={props?.primaryImageImage} classProps=" w-full aspect-video object-cover md:rounded-default " />
        </div>
    )
}
